import type { SidebarItem } from '@bv/router';

const sidebarItems: SidebarItem[] = [
  {
    title: 'Providers',
    route: { name: 'sms-providers' },
  },
  {
    title: 'Routes',
    route: { name: 'sms-routes' },
  },
  {
    title: 'Requests',
    route: { name: 'sms-requests' },
  },
];

export default sidebarItems;
